export default __webpack_public_path__ + "static/media/006-card games.94702798.svg";